(function ($) {
	$(document).ready(function () {
		$('input[name="cf-delivery"]').click(function () {
			$(
				'#ins_cert_cf_address, #ins_cert_cf_city_zip, #ins_cert_cf_email, #ins_cert_entity_fax',
			).removeClass('validate_me');
			var method = $(this).val();
			if (method == 'mail') {
				$('#ins_cert_cf_address, #ins_cert_cf_city_zip').addClass(
					'validate_me',
				);
			} else if (method == 'email') {
				$('#ins_cert_cf_email').addClass('validate_me');
			} else {
				$('#ins_cert_entity_fax').addClass('validate_me');
			}
		});

		formValidation();
	});

	$(window).load(function () {});

	$(window).resize(function () {});

	//functions
	//front end form validation
	function formValidation() {
		$('#request-quote-form').validate({
			rules: {
				qf_name: {
					required: true,
				},
				qf_address: {
					required: true,
				},
				qf_mail: {
					required: true,
				},
				qf_comp_by: {
					required: true,
				},
				qf_phone: {
					required: true,
				},
				qf_email: {
					required: true,
					email: true,
				},
				qf_eff_date: {
					required: true,
				},
				qf_des_date: {
					required: true,
				},
			},
			submitHandler: function (form) {
				form.submit();
			},
		});

		$('#user-registration-form').validate({
			rules: {
				user_reg_entity: {
					required: true,
				},
				user_reg_phone: {
					required: true,
				},
				user_reg_app_name: {
					required: true,
				},
				user_reg_app_entity: {
					required: true,
				},
				user_reg_app_date: {
					required: true,
				},
			},
			submitHandler: function (form) {
				form.submit();
			},
		});

		$('#reset-password-form').validate({
			rules: {
				password: {
					required: true,
					pwcheck: true,
					minlength: 8,
				},
				password2: {
					required: true,
					equalTo: '#password',
				},
			},
			submitHandler: function (form) {
				form.submit();
			},
		});

		$('#request-password-reset').validate({
			rules: {
				username: {
					required: true,
				},
			},
			submitHandler: function (form) {
				form.submit();
			},
		});

		$('#member-expense-form').validate({
			rules: {
				Attendee: {
					required: true,
				},
				member_entity: {
					required: true,
				},
				meeting_name_location: {
					required: true,
				},
				meeting_date: {
					required: true,
				},
			},
			submitHandler: function (form) {
				//var sz_form = $(form).serializeArray();
				//sendMemberExpenseForm(sz_form);
				form.submit();
			},
		});

		$('#loss-control-form').validate({
			rules: {
				name: {
					required: true,
					minlength: 2,
					maxlength: 50,
				},
				entity: {
					required: true,
					minlength: 2,
					maxlength: 50,
				},
				phone: {
					required: true,
				},
				email: {
					required: true,
					email: true,
				},
				prop_account: {
					number: true,
				},
				comp_account: {
					number: true,
				},
				total: {
					number: true,
				},
			},
			submitHandler: function (form) {
				var lc_serialized = $(form).serializeArray();
				// console.log(lc_serialized);
				var member_info = {
					id: $('input[name="loss-id"]').val(),
					name: $('input[name="loss-name"]').val(),
				};
				sendLossControlForm(lc_serialized, member_info);
			},
		});

		$.validator.addClassRules('validate_me', {
			required: true,
		});

		$.validator.addMethod(
			'atLeastOne',
			function (value, element) {
				return $('.checkbox-field-group :checkbox:checked').length > 0;
			},
			'Please check at least one',
		);

		$('#insurance-certificate-form').validate({
			groups: {
				// Group all checkboxes for error message display
				checks:
					'certificate_type_additional certificate_type_prop_loss certificate_type_prop_proof certificate_type_liab_proof certificate_type_work_comp certificate_type_fidelity railroad_proof_of_insurance equipment_breakdown_proof_of_insurance',
			},
			rules: {
				date: {
					required: true,
				},
				due_date: {
					required: true,
				},
				entity: {
					required: true,
				},
				address: {
					//required: true
				},
				city_zip: {
					//required: true
				},
				req_by: {
					required: true,
				},
				title: {
					required: true,
				},
				email: {
					required: true,
				},
				fax: {
					required: {
						depends: function () {
							return $('input[name=delivery]:checked').val() === 'fax'
								? true
								: false;
						},
					},
				},
				delivery: {
					required: true,
				},
				ch_holder: {
					required: true,
				},
				cf_address: {
					required: true,
				},
				cf_city_zip: {
					required: true,
				},
				cf_attention: {
					required: true,
				},
				cf_email: {
					required: {
						depends: function () {
							return $('input[name=cf-delivery]:checked').val() === 'email'
								? true
								: false;
						},
					},
				},
				cf_fax: {
					required: {
						depends: function () {
							return $('input[name=cf-delivery]:checked').val() === 'fax'
								? true
								: false;
						},
					},
				},
				cf_delivery: {
					required: true,
				},
				certificate_type_additional: { atLeastOne: true },
				certificate_type_prop_loss: { atLeastOne: true },
				certificate_type_prop_proof: { atLeastOne: true },
				certificate_type_liab_proof: { atLeastOne: true },
				certificate_type_work_comp: { atLeastOne: true },
				certificate_type_fidelity: { atLeastOne: true },
				railroad_proof_of_insurance: { atLeastOne: true },
				equipment_breakdown_proof_of_insurance: { atLeastOne: true },
				purpose: {
					required: true,
				},
			},
			messages: {
				delivery:
					'<span aria-describedby="ins_cert_delivery_mail ins_cert_delivery_email ins_cert_delivery_fax">Choose your delivery method</span>',
				cf_delivery:
					'<span aria-describedby="ins_cert_cf_delivery_mail ins_cert_cf_delivery_email ins_cert_cf_delivery_fax">Choose Certificate Holder delivery method</span>',
				certificate_type: 'Choose Type of Certificate',
			},
			submitHandler: function (form) {
				var serialized_form_data = $(form).serializeArray();
				// console.log(serialized_form_data);

				var member_info = {
					id: $('input[name="ins-member-id"]').val(),
					name: $('input[name="ins-member-name"]').val(),
				};
				sendInsuranceForm(serialized_form_data, member_info);
			},
		});

		$('#workers-comp-form').validate({
			rules: {
				// injury_date: {
				// 	required: true
				// },
				// employee_name: {
				// 	required: true,
				// 	minlength: 2,
				// 	maxlength: 100
				// },
				// social: {
				// 	required: true,
				// 	number: true,
				// 	minlength: 9,
				// 	maxlength: 9
				// },
				// cirsa_number: {
				// 	required: true,
				// 	number: true
				// },
				// employer: {
				// 	required: true,
				// 	minlength: 2,
				// 	maxlength: 75
				// },
				// last_day: {
				// 	required: true
				// },
				// returned_date: {
				// 	required: true
				// },
				// additional_info: {
				// 	required: true
				// },
				// name: {
				// 	required: true,
				// 	minlength: 2,
				// 	maxlength: 100
				// },
				// address: {
				// 	required: true,
				// 	minlength: 10,
				// 	maxlength: 100
				// },
				// phone: {
				// 	required: true
				// },
				// fax: {
				// 	required: true
				// }
			},
			submitHandler: function (form) {
				var wc_serialized = $(form).serializeArray();
				var member_info = {
					id: $('input[name="work-member-id"]').val(),
					name: $('input[name="work-member-name"]').val(),
				};
				sendWorkersCompForm(wc_serialized, member_info);
			},
		});

		$('#supervisor-accident-form').validate({
			rules: {
				entity_name: {
					required: true,
					minlength: 2,
					maxlength: 50,
				},
				loss_date: {
					required: true,
				},
				time: {
					required: true,
				},
				name: {
					required: true,
					minlength: 2,
					maxlength: 100,
				},
				location: {
					required: true,
					minlength: 2,
					maxlength: 100,
				},
				actions: {
					required: true,
				},
				improvements: {
					required: true,
				},
				investigated_title: {
					required: true,
					minlength: 2,
					maxlength: 50,
				},
				investigated_date: {
					required: true,
				},
				reviewed_title: {
					required: true,
					minlength: 2,
					maxlength: 50,
				},
				reviewed_date: {
					required: true,
				},
			},
			submitHandler: function (form) {
				var sa_serialized = $(form).serializeArray();
				var member_info = {
					id: $('input[name="sup-accident-id"]').val(),
					name: $('input[name="sup-accident-name"]').val(),
				};
				sendSupervisorAccidentForm(sa_serialized, member_info);
			},
		});

		//methods
		$.validator.addMethod(
			'phoneUS',
			function (phone_number, element) {
				phone_number = phone_number.replace(/\s+/g, '');
				return (
					this.optional(element) ||
					(phone_number.length > 9 &&
						phone_number.match(
							/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/,
						))
				);
			},
			'Please specify a valid phone number',
		);

		$.validator.addMethod(
			'numberCheck',
			function (value, element) {
				return (
					this.optional(element) ||
					/(^\d*\.?\d*[0-9]+\d*$)|(^[0-9]+\d*\.\d*$)/.test(value)
				);
			},
			'Please specify a valid number',
		);

		$.validator.addMethod(
			'addressCheck',
			function (value, element) {
				return (
					this.optional(element) ||
					/\b[A-Za-z]{2}\s+\d{5}(-\d{4})?\b/.test(value)
				);
			},
			'Please specify a valid state and zipcode',
		);

		//currency: ["$", false]
		$.validator.addMethod(
			'currency',
			function (value, element, param) {
				var isParamString = typeof param === 'string',
					symbol = isParamString ? param : param[0],
					soft = isParamString ? true : param[1],
					regex;

				symbol = symbol.replace(/,/g, '');
				symbol = soft ? symbol + ']' : symbol + ']?';
				regex =
					'^[' +
					symbol +
					'([1-9]{1}[0-9]{0,2}(\\,[0-9]{3})*(\\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\\.[0-9]{0,2})?|0(\\.[0-9]{0,2})?|(\\.[0-9]{1,2})?)$';
				regex = new RegExp(regex);
				return this.optional(element) || regex.test(value);
			},
			'Please specify a valid currency',
		);

		$.validator.addMethod(
			'vinUS',
			function (v) {
				if (v.length !== 17) {
					return false;
				}

				var LL = [
						'A',
						'B',
						'C',
						'D',
						'E',
						'F',
						'G',
						'H',
						'J',
						'K',
						'L',
						'M',
						'N',
						'P',
						'R',
						'S',
						'T',
						'U',
						'V',
						'W',
						'X',
						'Y',
						'Z',
					],
					VL = [
						1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9,
					],
					FL = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2],
					rs = 0,
					i,
					n,
					d,
					f,
					cd,
					cdv;

				for (i = 0; i < 17; i++) {
					f = FL[i];
					d = v.slice(i, i + 1);
					if (i === 8) {
						cdv = d;
					}
					if (!isNaN(d)) {
						d *= f;
					} else {
						for (n = 0; n < LL.length; n++) {
							if (d.toUpperCase() === LL[n]) {
								d = VL[n];
								d *= f;
								if (isNaN(cdv) && n === 8) {
									cdv = LL[n];
								}
								break;
							}
						}
					}
					rs += d;
				}
				cd = rs % 11;
				if (cd === 10) {
					cd = 'X';
				}
				if (cd === cdv) {
					return true;
				}
				return false;
			},
			'The specified vehicle identification number (VIN) is invalid.',
		);
	}

	//send Member expense form data
	function sendMemberExpenseForm(sz_form) {
		//console.log(sz_form);
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'member_expense_form',
				value: sz_form,
			},
			success: function (response) {
				// console.log(response);
				var info = JSON.stringify(response);
				//console.log(info);
				//reset form
				$('#member-expense-form').each(function () {
					this.reset();
				});
				$('.forms-message').fadeToggle('fast');
				dataLayer.push({ event: 'member_expense' });
			},
			error: function (error) {
				var err = JSON.stringify(error);
				console.log('there has been an error: ' + err);
			},
		});
	}

	//send loss control data to backend
	function sendLossControlForm(lc_serialized, member_info) {
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'loss_control_form',
				value: lc_serialized,
				member: member_info,
			},
			success: function (response) {
				//reset form
				$('#loss-control-form').each(function () {
					this.reset();
					$('.file-field.form-upload p').remove();
				});
				$('.forms-message').fadeToggle('fast');
				dataLayer.push({ event: 'credit_account' });
			},
			error: function (error) {
				var err = JSON.stringify(error);
				console.log('there has been an error: ' + err);
			},
		});
	}

	//send insurance form to backend
	function sendInsuranceForm(serialized_form_data, member_info) {
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'send_ins_form',
				value: serialized_form_data,
				member: member_info,
			},
			success: function (response) {
				//console.log(response);
				var res = $.parseJSON(response);
				var url;
				// console.log(res);
				if (res.type == 'staffCIR') {
					url =
						'/employee_page/underwriting-rep-tools/search-insurance-requests/?preview=';
				} else {
					url = '/member/coverage-center/search-insurance-requests/?preview=';
				}
				$('.form_preview').attr('href', url + res.id);
				//reset form
				$('#insurance-certificate-form').each(function () {
					this.reset();
				});
				$('.forms-message').fadeToggle('fast');
				dataLayer.push({ event: 'insurance' });
				// Traps focus within the success message modal
				trapFocus('.forms-message');
				// Focus on the close button
				$('.forms-message-close').focus();
				// Close modal on Escape key
				$(document).on('keyup', function (e) {
					if (e.key === 'Escape' || e.keyCode === 27) {
						$('.forms-message-close').click();
					}
				});
			},
			error: function (error) {
				console.log('there has been an error: ' + error);
			},
		});
	}

	// Traps focus within the success message modal
	function trapFocus(modalSelector) {
		const modal = document.querySelector(modalSelector);
		if (!modal) return;

		const focusableElements = modal.querySelectorAll(
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		modal.addEventListener('keydown', function (e) {
			if (e.key === 'Tab' || e.keyCode === 9) {
				if (e.shiftKey) {
					// Shift + Tab
					if (document.activeElement === firstFocusable) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					// Tab
					if (document.activeElement === lastFocusable) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}
		});
	}

	//send work comp form to backend
	function sendWorkersCompForm(wc_serialized, member_info) {
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'send_workcomp_form',
				value: wc_serialized,
				member: member_info,
			},
			success: function (response) {
				var res = $.parseJSON(response);
				var url;
				// console.log(res);
				// if (res.type == 'staffWCR') {
				// 	url = '/employee_page/view-report-of-return-to-work/?preview=';
				// } else {
				// 	url = '/form-search-member/?preview='; //need member page url
				// }
				// $('.form_preview').attr('href', url+res.id);

				//reset form
				$('#workers-comp-form').each(function () {
					this.reset();
				});
				$('.forms-message').fadeToggle('fast');
				dataLayer.push({ event: 'workers_comp' });
			},
		});
	}

	//send supervisor accident form to backend
	function sendSupervisorAccidentForm(sa_serialized, member_info) {
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'send_accident_form',
				value: sa_serialized,
				member: member_info,
			},
			success: function (response) {
				var info = JSON.stringify(response);
				// console.log(info);
				//reset form
				$('#supervisor-accident-form').each(function () {
					this.reset();
				});
				$('.forms-message').fadeToggle('fast');
				dataLayer.push({ event: 'accident_form' });
			},
		});
	}
})(jQuery);
